<template>
  <v-app style="margin-top:0px;" >
      <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
          <v-container>
              <h1 style="margin-top:20px;">{{ countryName }}</h1>
          </v-container>
      </v-card>
<div class="container con" >
      <div class="row" style="margin-top:-100px; " >
        <div class="col-lg-9 col-md-9 col-sm-12" >
      <v-card flat style="border: 1px solid #b6b6b6;">
      <v-container>
          <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
            <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
            <img :src="image" style="width: 50%;height:300px;" />
          <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;">
            <h3 class="country-heading"><strong>Study in Canada</strong></h3>
            <p><strong>Geographical location of Canada:</strong></p>
            <p> A nation in North America is called Canada. It is the second-largest nation in terms of total area and has the longest coastline in the globe. Its 10 provinces and three territories stretch from the Atlantic to the Pacific and northward into the Arctic Ocean. It is distinguished by a vast variety of geological and meteorological zones. In this thinly populated nation, most people live in cities south of the 55th parallel. The three main metropolitan centres in Canada are Toronto, Montreal, and Vancouver, and Ottawa serves as the country's capital.</p>
            <p><strong>How Canada’s economy emerging as world’s one of the largest economy nationwide:</strong></p>
            <p>With a nominal GDP of over US$2.221 trillion and the eighth-largest economy in the world as of 2022, Canada has a highly developed mixed-market economy. With a highly globalized economy, it is one of the major trading nations in the world. Canada's trade in goods and services totaled $2.016 trillion in 2021. Over $637 billion worth of commodities were exported from Canada, while over $631 billion worth of goods were imported, $391 billion of which came from the United States. Canada had a $22 billion trade imbalance in goods and a $25 billion trade deficit in services in 2018.</p>
            <p><strong>Cultural Aspects of Canada</strong></p>
            <p>Canadian culture is influenced by the wide variety of ethnicities that make up the country, and laws that advance a "just society" are guaranteed by the constitution. Canada has prioritized inclusivity and equality for all of its citizens. Multiculturalism as the official state policy is frequently considered as one of Canada's notable achievements and a crucial component of Canadian identity. In Quebec, there is a strong sense of cultural identity and a French Canadian culture apart from the English Canadian culture. Theoretically, Canada is a cultural mosaic made up of several regional ethnic subcultures.</p>
            <p><strong>Why students from nations and worldwide want to pursue their higher study from Canada</strong></p>
            <ul>
               <li>Highly regarded organizations</li>
               <li>A lot of people speak English</li>
               <li>better employment prospects both during and after education</li>
               <li>superior living and educational standards</li>
               <li>Multicultural surroundings</li>
               <li>Take the High Road to Success for a Taste of the Tech Sector</li>
               <li>Gain knowledge of and opportunity to master many languages</li>
               <li>Get a Guaranteed Job After Graduation.</li>
          </ul>

          <h3 class="country-heading">Process of Study in Canada?</h3>
          <p><strong>Step 1:</strong> Investigate Your Options <br>Decide what you want to study, where you want to live, the total cost, the opportunities available, etc. before you shortlist the colleges.</p>
          <p><strong>Step 2:</strong> Choose Universities: Make a shortlist of the colleges (about 10) and study options that best fit your needs and those you wish to apply to.</p>
          <p><strong>Step 3:</strong> Get ready for admissions tests: Based on the requirements of the universities and colleges, prepare for the standardized examinations, such as the TOEFL, GRE, GMAT, and IELTS. Pre-register for these exams. You should account for the time needed in case you need to repeat the test while applying for the exams. These examinations should be finished by September of the desired application year.<br></p>
          <p><strong>Step 4:</strong> Pay for your education: <br>Make sure you have the money set up for your full year of study in Canada, as well as for housing, local transportation, food, and other incidentals. Choose your study financing options, such as personal savings, student loans, scholarships, or an assistantship. </p>
          <p><strong>Step 5:</strong> Apply to universities. For information on admission requirements, get in touch with each university directly. Each university has its own criteria for admission. Complete the applications and submit them well before the deadlines.</p>
          <p><strong>Confirm admission in Step 6:</strong> After receiving acceptance letters from the colleges you applied to, select the one where you want to enroll. The institution will receive a non-refundable deposit as the next step in confirming your acceptance to study in Canada.</p>
          <p><strong>Step 7:</strong> Apply for a Student Visa Once your admission has been confirmed, you can submit an application for a student visa. <br> A visiting visa or Electronic Travel Authorization (ETA) is always required to travel with a study permit. Please be aware that although a guest visa or ETA enables one to enter Canada, a study permit only permits anyone to study there. Your expert will connect you with authorized migration professionals and assist you in getting access to the most recent information.</p>

           <h4 class="country-heading">Top Universities to study in Canada:</h4>


          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Institution</th>
                            <th style="text-align: center;">QS Ranking 2023</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>University of Toronto</td>
                            <td style="text-align: center;">34</td>
                          </tr>
                          <tr>
                            <td>McGill University</td>
                            <td style="text-align: center;">31</td>
                          </tr>
                          <tr>
                            <td>University of British Columbia</td>
                            <td style="text-align: center;">47</td>
                          </tr>
                          <tr>
                            <td>University of Montreal</td>
                            <td style="text-align: center;">116</td>
                          </tr>
                          <tr>
                            <td>University of Alberta</td>
                            <td style="text-align: center;">110</td>
                          </tr>
                          <tr>
                            <td>McMaster University</td>
                            <td style="text-align: center;">152</td>
                          </tr>
                          <tr>
                            <td>University of Waterloo</td>
                            <td style="text-align: center;">172</td>
                          </tr>
                        </tbody>
                      </table>
          </div>
          <h4 class="country-heading">The best academic programs in Canada:</h4>
          <h4 class="country-heading">The most well-liked courses available for study in Canada are shown below:</h4>
             <ul>
              <li>Science of computers</li>
              <li>Business</li>
              <li>Engineering</li>
              <li>Medical fields</li>
              <li>Physiotherapy</li>
              <li>Computer technology</li>
              <li>Gaming and animation</li>
              <li>Hospitality</li>

             </ul>

             <h4 class="country-heading">Cost of education in Canada</h4>
             <p>Depending on the degree program and school you choose, tuition costs will vary. You will require around between CAD 13,000 and CAD 35,000 each year to cover this.</p>
             <p>Those in the humanities, education, and the arts are often a little less expensive, but those in the sciences and engineering are probably to be more expensive. The tuition price is normally greater and the fees vary based on the program if you want to pursue postgraduate education. MBA programs are frequently the most expensive, as is true in most other nations. These courses typically cost between 30,000 and 42,000 CAD.</p>

             <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Degree Course</th>
                            <th style="text-align: center;">Average Annual Fee</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Undergraduate degree</td>
                            <td style="text-align: center;">$13,000- $20,000</td>
                          </tr>
                          <tr>
                            <td>Post Graduate master’s degree</td>
                            <td style="text-align: center;">$17000- $25000</td>
                          </tr>
                          <tr>
                            <td>Doctoral Degree</td>
                            <td style="text-align: center;">$7000-$15000</td>
                          </tr>
                          <tr>
                            <td>Masters of Business administration</td>
                            <td style="text-align: center;">$30000-$40000</td>
                          </tr>

                        </tbody>
                      </table>
          </div>
          
          
          <h4 class="country-heading">Required Documents to study in Canada:</h4>
          <h4 class="country-heading">UG Courses</h4>
             <p>1) Application Form</p>
             <p>2) 10th Mark sheet and Certificate –Notary attested</p>
             <p>3) 12th Mark sheet and Certificate- Notary attested</p>
             <p>4) Passport Copy – First and Last Page – Notary attested</p>
             <p>5) Letters of Recommendation – 2</p>
             <p>6) Statement of Purpose (Duly Signed by Student)</p>
             <p>7) Resume.</p>
             <p>8) IELTS or TOEFL score card if required–Notary attested</p>
             <p>9) Experience certificate – if any</p>
             <p>10) Birth Certificate</p>
             <p>11) Photograph</p>

             <h4 class="country-heading">PG Courses:</h4>
             <p>1) Application Form</p>
             <p>2) 10th Mark sheet and Certificate –Notary attested</p>
             <p>3) 12th Mark sheet and Certificate- Notary attested</p>
             <p>4) Bachelor’s Degree – All individual Mark sheets and consolidated Mark sheet- Notary attested</p>
             <p>5) Degree Certificate or Provisional Degree Certificate- Notary attested 6) Passport Copy – First and Last Page – Notary attested</p>
             <p>7) Letters of Recommendation – 2</p>
             <p>8) Statement of Purpose (Duly Signed by Student) 9) Resume. 10) IELTS or TOEFL score card if required–Notary attested 11) Experience certificate – if any 12) Birth Certificate 13) Photograph</p>
             <h4 class="country-heading">Canadian employment prospects</h4>
             <p>Over the past several years, Canada has welcomed many foreign students from many countries and has offered both students and working professionals a variety of job options. Canada is regarded as the top G20 nation for starting a business, according to rankings, published by Forbes and US News. Additionally, The Economist Intelligence Unit projects that over the next five years, from 2018 to 2022, the nation will be ranked as the third best G7 nation for doing business, which only suggests that an abundance of job opportunities will be available to international students both during and after they have finished their studies. </p>


   


           
          </div>     
        </div>
        </v-container>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                  <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Interested in studying abroad?</h3>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>
          </v-card>
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
            <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Universities</h3>
                  </div>
             <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
               <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>

             </marquee>
          </v-card>

              <div class="">
                <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
              </div>
            <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
              <div style="margin:0px;cursor: pointer; ">
                <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
              </div>
            </v-card>

        </div>
      </div>
    </div>
      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
import moment from 'moment';
export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],
      featuredUniversities: [],

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      details: null,
      image: null,
      banner: null,
      countryId: null,
      countryName: sessionStorage.getItem("countryName"),

      countries: [],
      selectedCountry: null,

      courses: [],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
    // this.axios
    //     .get(config.API + `country/author/${this.$route.params.id}`, {
    //       headers: {
    //         Authorization: "bearer " + sessionStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       let _data = res.data.author;
    //       this.details = _data;
          
    //       if(_data.image!=null) {
    //         this.image = config.API + 'country/files1/' + _data.image;
    //       }
    //       if(_data.banner!=null) {
    //         this.banner = config.API + 'country/files2/' + _data.banner;
    //         console.log(this.banner);
    //       }
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });

      this.countryName = sessionStorage.getItem("countryName");
      this.image = sessionStorage.getItem("image");
      this.banner = sessionStorage.getItem("banner");
      this.countryId = sessionStorage.getItem("countryId");
        this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if(element.id!=this.countryId) {
            this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
            })
          }
        }

        console.log(this.countries);
      });

      this.axios
    .get(`https://api.worldwin.org/api/Levels`, {
      headers: { Authorization: "Bearer " + sessionStorage.token }
    })
    .then(res => {
      let list = res.data;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        
        this.courses.push(element.levelName)
      }
    });


    this.axios
        .post(
          config.API + `university/search`,
          {
            countryId: this.countryId
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          let list = res.data.result;
          console.log(list);

          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            this.featuredUniversities.push({
              id: element.id,
              universityName: element.universityName,
              src: config.API1 + "university/files/" + element.src
            })
          }
            })
        .catch(err => {
        });
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },
   getOtp() {
    if (this.$refs.form.validate()) {
      this.btnSave = true;
      this.axios
        .post(
          config.API + `enquiry/author`,
          {
            name: this.form.name,
            email: this.form.email,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            country: this.selectedCountry,
            course: this.selectedCourse,
            page: 'Country Details',
            date: moment().format('MMMM Do YYYY')
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          console.log(res);
          this.name = this.form.name.split(' ');
          let firstName = this.name[0];
          let lastName = null;

          if(this.name.length > 2) {
            lastName = this.name[1] + this.name[2]
          }
          else {
            lastName = this.name[1]
          }

          let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
          this.axios
        .post(
          `https://api.worldwin.org/api/Leads1`,
          {
            firstName: firstName,
            lastName: lastName,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            cmsId: JSON.parse(res.data.result.id),
            email: this.form.email,
            guardianName: null,
            comment: comment,
            pageName: 'Country Details',
            guardianNo: 0,
            guardianEmail: null,
            relation: null,
            address: null,
            nature: null,
            source: "Website",
            document: false,
            documentType: null,
            notes: null,
            levelId: 0,
            leadDetails: null,
            leadTrainings: null
          },
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.dialog = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error(`Mobile no is already registered`);
          this.btnSave = false;
        });
        })
        .catch(() => {
          this.$toaster.error("Mobile no is already registered");
          this.btnSave = false;
        });
      }
      /* this.pin = Math.floor(1000 + Math.random() * 9000);
      this.axios
        .post(
          config.API + 'enquiry/otp',
          {
            name: this.form.name,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            otp: this.pin
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(() => {
          this.otp = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error("Mobile number already exists!!");
          this.btnSave = false;
        }); */
    /* } else {
      this.$toaster.error(`Required field are empty!!`);
    } */
  },
  onCountry(item) {
  sessionStorage.setItem("countryName", item.countryName);
  sessionStorage.setItem("image", item.image);
  sessionStorage.setItem("banner", item.banner);
  sessionStorage.setItem("countryId", item.id); 
  ////this.$router.push("/countrydetail/" + item.id );
  if(item.countryName=='UK') {
    this.$router.push("/study-in-uk");
  }
  else if(item.countryName=='DUBAI') {
    this.$router.push("/study-in-dubai");
  }
  else if(item.countryName=='SINGAPORE') {
    this.$router.push("/study-in-singapore");
  }
  else if(item.countryName=='USA') {
    this.$router.push("/study-in-usa");
  }
  else if(item.countryName=='AUSTRALIA') {
    this.$router.push("/study-in-australia");
  }
  else if(item.countryName=='CANADA') {
    this.$router.push("/study-in-canada");
  }
  
 },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.form.name = null;
      this.form.email = null;
      this.form.mobileNumber = null;
      this.otp = false;
      this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
  background-size: cover;
  height:200px;
}
.tst {
  border-radius:0px;
  height:300px;
  background-size: cover;
  color: white !important;
    
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.tourtheme {
  height: 190px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 120%;
}
.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}
.country-heading {
  color:#EC1616;
}
.country p {
  font-weight: 300;
  color:#666666;
  text-align: justify;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.con {
  margin-top: -100px;
  max-width: 1300px;
}
@media screen and (min-width: 768px){
  .con {
    margin-top: 0px!important;}

  }
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
